// src/service/websocket/NiftyWebsocketApi.jsx

import { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { environment } from "environment/environment"; // absolute import

const NIFTY_WEBSOCKET_URL = environment.niftyWebsocketUrl;

const useNiftyWebsocket = () => {
  const [options, setOptions] = useState([]);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return; // SSR safety

    const stompClient = new Client({
      webSocketFactory: () => new SockJS(NIFTY_WEBSOCKET_URL),
      reconnectDelay: 5000, // auto-reconnect
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      debug: () => {}, // disable debug logs
    });

    stompClient.onConnect = () => {
      setIsConnected(true);
      const topic = "/index-api-topic/option-data";

      stompClient.subscribe(topic, (message) => {
        try {
          setOptions(JSON.parse(message.body));
        } catch (err) {
          console.error("Failed to parse message:", err);
        }
      });
    };

    stompClient.onStompError = (frame) => {
      console.error("Broker reported error:", frame.headers["message"]);
      console.error("Additional details:", frame.body);
    };

    stompClient.activate();

    return () => {
      if (stompClient.active) {
        stompClient.deactivate();
      }
    };
  }, []);

  return { options, isConnected };
};

export default useNiftyWebsocket;
